import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAppStore = create(
  persist(
    (set) => ({
      nightMode: true,
      toggleNightMode: () => set((s) => ({ nightMode: !s.nightMode })),
      setNightMode: (value) => set({ nightMode: !!value }),
      wiltWarningSeen: false,
      markWiltWarningSeen: () => set({ wiltWarningSeen: true }),
      strictMode: false,
      toggleStrictMode: () => set((s) => ({ strictMode: !s.strictMode })),
    }),
    {
      name: 'pomogrow-app',
      partialize: (state) => ({
        nightMode: state.nightMode,
        wiltWarningSeen: state.wiltWarningSeen,
        strictMode: state.strictMode,
      }),
    }
  )
);
